// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZGPLeJUgXcwDKBXT7Zt7{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary,#fff);border-radius:6px;align-items:center;gap:4px;padding:4px 8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ZGPLeJUgXcwDKBXT7Zt7`
};
export default ___CSS_LOADER_EXPORT___;
